import {
    getDomainWithSubdomain,
    getUrlComponents,
} from "pro-features/components/AutocompleteWebsites/urlComponentUtils";

const CONTAINS_WHITESPACE_REGEX = /\s/;

/**
 * Reduces every way a user can write a host - protocol, "www.", port, path, casing - to the single
 * canonical domain the API stores, so "https://www.revolut.com" and "revolut.com" compare as equal.
 */
export const normalizeDomain = (input: string): string => {
    const trimmedInput = input?.trim() ?? "";

    // getUrlComponents deliberately extracts the likeliest URL out of noisy text, so without this
    // guard a phrase such as "contact us at revolut.com" would normalize to a valid domain.
    if (!trimmedInput || CONTAINS_WHITESPACE_REGEX.test(trimmedInput)) {
        return "";
    }

    const { domain, subdomain } = getUrlComponents(trimmedInput);

    // getUrlComponents falls back to the public suffix when psl finds no registrable domain, which
    // would turn a bare "com" into a valid-looking result.
    if (!domain?.includes(".")) {
        return "";
    }

    return getDomainWithSubdomain(domain, subdomain ?? "").toLowerCase();
};
